import Site from 'Site';
import { BaseJs } from '@gate31/core/src/libs/BaseJsComponents';
import LiquidRender from '@gate31/uikit/common/scripts/liquid-render';
import { ModalDesk } from '../ModalDesk/ModalDesk';

export class DolyamiModalDesk {
    static cn = new BaseJs.BuildCn('DolyamiModalDesk');

    trigger: HTMLElement;
    modal: ModalDesk;

    constructor({ trigger }: { trigger: HTMLElement }) {
        this.trigger = trigger;
        this.modal = new ModalDesk({
            template: 'modal-desk-template',
            content: DolyamiModalDesk.getContent(),
            disableBodyScroll: true,
            viewOpts: {
                closeIconSize: 'm',
                className: 'DolyamiModalDesk'
            }
        });

        this.connectionCallback();
    }

    connectionCallback() {
        this.trigger.addEventListener('click', () => {
            this.modal.open();
        });
    }

    static getContent() {
        return LiquidRender.render('dolyami-content-desk-template', {
            logo: Site.themeAssets.images.dolyami
        });
    }
}
